import api from '@/services/api/api'

class StylesService {
  getAllStyles () {
    return api.get('style').then(result => {
      return result.data
    })
  }

  saveStyle (style) {
    return api.post('style', style)
  }

  removeStyle (style) {
    return api.delete('style/' + style.id)
  }
}

export default new StylesService()



// WEBPACK FOOTER //
// ./src/services/codebooks/StylesService.js